import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/psx-frontend/psx-frontend/app/indices/[index]/relative-strength/RelativeStrengthClient.tsx");
